import type { SeatMapRulesFile, SeatMapRuleSet } from '../models/types';
import type { SectorPreviewTransform } from '../models/types';

export const fallbackRules: SeatMapRulesFile = {
  default: {
    rotation: { desktopDeg: -90, mobileDeg: 0 },
    initialScale: { desktop: 0.14, mobile: 0.07 },
    minScale: { desktop: 0.1, mobile: 0.07 },
  },
};

export const parseSeatMapRules = (source: unknown): SeatMapRulesFile | null => {
  if (!source) return null;

  const tryObject = (value: unknown) =>
    value && typeof value === 'object' && 'default' in value ? (value as SeatMapRulesFile) : null;

  if (typeof source === 'string') {
    try {
      return tryObject(JSON.parse(source));
    } catch {
      return null;
    }
  }

  return tryObject(source);
};

export const resolveRuleSet = (
  rules: SeatMapRulesFile,
  eventOrShowId?: string | number | null
): SeatMapRuleSet => {
  const key = eventOrShowId ? String(eventOrShowId) : undefined;
  return (key && rules.shows?.[key]) || rules.default;
};

export const getSectorPreviewTransform = (rules: SeatMapRuleSet): SectorPreviewTransform => ({
  x: rules.sectorPreviewTransform?.translate?.[0] ?? 0,
  y: rules.sectorPreviewTransform?.translate?.[1] ?? 0,
  scaleX: rules.sectorPreviewTransform?.scale?.[0] ?? 1,
  scaleY: rules.sectorPreviewTransform?.scale?.[1] ?? 1,
  rotateDeg: rules.sectorPreviewTransform?.rotateDeg ?? 0,
});
